var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChartWaterfall = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.5 2.25C1.5 1.83579 1.16421 1.5 0.75 1.5C0.335786 1.5 0 1.83579 0 2.25V21.75C0 22.1642 0.335786 22.5 0.75 22.5H23.25C23.6642 22.5 24 22.1642 24 21.75C24 21.3358 23.6642 21 23.25 21H1.5V2.25Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 12.75C4.5 12.3358 4.83579 12 5.25 12C5.66421 12 6 12.3358 6 12.75V17.25C6 17.6642 5.66421 18 5.25 18C4.83579 18 4.5 17.6642 4.5 17.25V12.75Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M9 8.25C9 7.83579 9.33579 7.5 9.75 7.5C10.1642 7.5 10.5 7.83579 10.5 8.25V12.75C10.5 13.1642 10.1642 13.5 9.75 13.5C9.33579 13.5 9 13.1642 9 12.75V8.25Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 5.25C13.5 4.83579 13.8358 4.5 14.25 4.5C14.6642 4.5 15 4.83579 15 5.25V9.75C15 10.1642 14.6642 10.5 14.25 10.5C13.8358 10.5 13.5 10.1642 13.5 9.75V5.25Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M18 5.25C18 4.83579 18.3358 4.5 18.75 4.5C19.1642 4.5 19.5 4.83579 19.5 5.25V17.25C19.5 17.6642 19.1642 18 18.75 18C18.3358 18 18 17.6642 18 17.25V5.25Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChartWaterfall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chart-waterfall.95c5b2b3f315523f044e5cc7e5128659.svg";